import React from "react";
import CountUp from "react-countup";
import { useNavigate } from "react-router-dom";

const Hero = () => {
  const navigate = useNavigate();

  const handlePostJob = () => {
    // Navigate to the HomeRegister page when the button is clicked
    navigate("/HomeRegister"); // Make sure the route is correct
  };

  const handleEmployerLogin = () => {
    navigate("/EmployerLogin");
  };

  const handleEmployeeLogin = (event) => {
    event.preventDefault(); // Prevent form submission if inside a form
    navigate("/HomeLogin");
  };
  return (
    <>
      {/* // <div className="bg-background flex flex-col items-center justify-center"> */}
      <section className="bg-background flex flex-col items-center justify-center ">
        {/* Centered Container */}
        <div className="w-full max-w-3xl">
          {/* Live Jobs Section */}
          <div className="text-2xl lg:text-3xl font-semibold mb-6 mt-12 text-center text-textWhite font-josefin">
            <p>
              We have <span className="text-background2">208,000+</span> Live Jobs
            </p>
          </div>

          {/* Title Section */}
          <div className="text-3xl md:text-4xl lg:text-5xl font-semibold mb-6 text-center  text-textWhite font-josefin">
            <h1>
              Find the <span className="text-background2">Job</span> that fits your life
            </h1>
          </div>

          {/* Subtitle */}
          <p className="mb-6 text-center text-xl text-textWhite font-josefin font-semibold">
            Type your keyword, then click search to find your perfect job
          </p>

          {/* Job Search Form */}
          <div className="bg-boxes py-4 px-5 rounded-lg mx-auto w-full">
            <form className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="flex flex-col">
                <input
                  type="text"
                  placeholder="Jobs.."
                  className="font-bold w-full py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-background2 text-center placeholder:text-black placeholder:font-josefin placeholder:text-xl drop-shadow-xl "
                />
              </div>

              <div className="flex flex-col">
                <input
                  type="text"
                  placeholder="Types.."
                  className="font-bold w-full py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-background2 text-center placeholder:text-black placeholder:font-josefin placeholder:text-xl drop-shadow-xl"
                />
              </div>

              <div className="flex flex-col">
                <input
                  type="text"
                  placeholder="Search.."
                  className="font-bold w-full py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-background2 text-center placeholder:text-black placeholder:font-josefin placeholder:text-xl drop-shadow-xl "
                />
              </div>
              <div className="bg-logos  ml-4 h-10 w-40 rounded-lg flex justify-center items-center py-2 drop-shadow-xl">
                <button
                  className="text-textWhite font-bold  w-32 rounded-md font-josefin"
                  onClick={handleEmployeeLogin}
                >
                  Find a Job
                </button>
              </div>
            </form>
          </div>

          {/* Popular Searches */}
          <p
            className="mt-6 text-xl text-textWhite font-josefin mb-12
        "
          >
            <span className="font-bold ">Popular searches:</span> Developer, Designer, Architect,
            Engineer...
          </p>
        </div>
      </section>

      {/* Post Job Section */}

      <section className="">
        <div className="mt-2 py-10 flex flex-col items-center bg-background  w-full ">
          {/* Heading */}
          <h2 className="text-3xl md:text-4xl font-bold  text-textWhite font-josefin text-Red mb-6 text-center">
            Post your job on JobGenee to reach millions of users
          </h2>

          {/* Button */}
          <button
            className="px-6 py-3 text-textWhite border-2 border-logos rounded-full hover:bg-logos hover:text-textWhite transition duration-300 font-semibold"
            onClick={handleEmployerLogin}
          >
            Post a job
          </button>
        </div>
      </section>

      {/* Stats Section */}
      <section className="min-h-[120px] bg-background2 pb-8 lg:pb-0 w-full mt-2">
        <section className="stats-part pt-4">
          <div className="stats grid grid-cols-2 lg:grid-cols-4 text-white gap-4 px-4">
            <div className="stat flex flex-col justify-center items-center">
              <h3 className="text-3xl lg:text-4xl font-bold text-background font-josefin pb-2">
                <CountUp end={25} duration={8} />
                M+
              </h3>
              <p className="text-sm lg:text-base text-background font-josefin font-bold">Jobs Available</p>
            </div>
            <div className="stat flex flex-col justify-center items-center">
              <h3 className="text-3xl lg:text-4xl font-bold text-background font-josefin pb-2">
                <CountUp end={177} duration={8} />
                K+
              </h3>
              <p className="text-sm lg:text-base text-background font-josefin font-bold">New Jobs This Week!</p>
            </div>
            <div className="stat flex flex-col justify-center items-center">
              <h3 className="text-3xl lg:text-4xl  text-background font-josefin font-bold pb-2">
                <CountUp end={298} duration={8} />
                K+
              </h3>
              <p className="text-sm lg:text-base text-background font-josefin
               font-bold">Companies Hiring</p>
            </div>
            <div className="stat flex flex-col justify-center items-center">
              <h3 className="text-3xl lg:text-4xl text-background font-josefin font-bold pb-2">
                <CountUp end={5} duration={5} />
                M+
              </h3>
              <p className="text-sm lg:text-base text-background font-josefin font-bold">Candidates</p>
            </div>
          </div>
        </section>
      </section>
      <section >
        {/* Get Job Section */}
        <div className=" mt-2 py-10 flex flex-col items-center bg-background  w-full">
          {/* Heading */}
          <h2 className="text-3xl md:text-4xl font-bold text-textWhite font-josefin text-Red mb-6 text-center">
            Create a JobGenne profile and connect with your colleagues, classmates, and friends.
          </h2>

          {/* Button */}
          <button
            className="px-6 py-3 text-textWhite border-2 border-logos rounded-full hover:bg-logos hover:text-white transition duration-300 font-semibold"
            onClick={handlePostJob}
          >
            Get Started
          </button>
        </div>
      </section>

      {/* </div> */}
    </>
  );
};
export default Hero;
